/**
 * @internal
 */
export var numarray = function (s, base) {
    if (base === void 0) { base = 10; }
    return s ? s.split(' ').map(function (n) { return parseInt(n, base); }) : [];
};
/**
 * @internal
 */
export var stringToObject = function (raw, d1, d2) {
    var o = {};
    for (var _i = 0, _a = raw.split(d1); _i < _a.length; _i++) {
        var part = _a[_i];
        var _b = part.split(d2), k = _b[0], v = _b[1];
        o[k] = v;
    }
    return o;
};
/**
 * @internal
 */
export var leftPad = function (s, w) {
    s = typeof s === 'number' ? String(s) : s;
    var d = w - s.length;
    var r = '';
    while (d-- > 0) {
        r += ' ';
    }
    return r + s;
};
